export function getLicenseForProvince(licenses: any[] = [], province?: string) {
  const normalizedProvince = province?.toUpperCase?.();
  return (
    licenses.find(
      license => license?.jurisdiction?.toUpperCase?.() === normalizedProvince
    ) ||
    licenses.find(license => license?.jurisdiction?.toUpperCase?.() === 'ON') ||
    licenses[0]
  );
}
